<template>
  <FinderCard
    data-test="finder-usage-card"
    :title="criterion.title"
    :tooltip="criterion.tooltip"
  >
    <ul class="flex flex-col gap-8 min-w-0">
      <li v-for="value in displayedValues" :key="value.name">
        <RevButtonBase
          :aria-pressed="isSelected(value.name)"
          class="w-full text-left rounded-lg border-1 border-transparent px-16 py-14 motion-safe:transition motion-safe:duration-[225ms] outline-2 outline-offset-4 focus-visible:outline-default-hi"
          :class="
            isSelected(value.name)
              ? 'bg-action-default-mid-pressed text-onaction-default-mid-pressed hover:bg-action-default-mid-hoverpressed'
              : 'bg-action-default-mid text-onaction-default-mid hover:bg-action-default-mid-hover'
          "
          :data-state="isSelected(value.name) ? 'selected' : 'unselected'"
          data-test="finder-usage-pill"
          @click="toggleValue(value.name)"
        >
          <span class="heading-3 block truncate">{{ value.label }}</span>
        </RevButtonBase>
      </li>
    </ul>
  </FinderCard>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

import type { Facet } from '@backmarket/nuxt-layer-recommendation/filtering/types'
import { RevButtonBase } from '@ds/components/ButtonBase'

import type { FinderUsagesCriterion } from '../../../../composables/useFinder/useFinder.types'
import { useFinderTracking } from '../../../../composables/useFinder/useFinderTracking'
import FinderCard from '../FinderCard/FinderCard.vue'

const MAX_DISPLAYED_VALUES = 4

const props = defineProps<{
  criterion: FinderUsagesCriterion
  facet?: Facet
}>()

const displayedValues = computed(
  () => props.facet?.values.slice(0, MAX_DISPLAYED_VALUES) ?? [],
)

const selectedValues = defineModel<string[]>({ default: () => [] })

const { trackFinderOptionClick } = useFinderTracking()

function isSelected(value: string): boolean {
  return selectedValues.value.includes(value)
}

function toggleValue(value: string): void {
  trackFinderOptionClick(
    displayedValues.value.map((v) => ({ id: v.name, label: v.label })),
    value,
  )

  const current = selectedValues.value

  selectedValues.value = current.includes(value)
    ? current.filter((v) => v !== value)
    : [...current, value]
}
</script>
